import type { AccuracyReportFilters, MockJob, UrlStatus } from '../types/accuracy';

export interface EvaluationUrlPreview {
  job_id: string;
  job_name: string;
  url_id: string;
  url: string;
  status: UrlStatus;
  violation_count: number;
  existence_category_count: number;
}

export interface EvaluationScopePreview {
  filters: AccuracyReportFilters;
  included: EvaluationUrlPreview[];
  /** URLs in selected jobs that do not match the status filter */
  excluded: EvaluationUrlPreview[];
}

export const URL_STATUS_LABELS: Record<UrlStatus, string> = {
  pending: '保留中',
  processing: '処理中',
  review_pending: 'レビュー待ち',
  reviewed: 'レビュー済み',
  failed: '失敗',
  skipped: 'スキップ',
  completed: '完了',
};

export function resolveReportFilters(params: {
  selectedJobIds: string[];
  selectedStatuses: UrlStatus[];
  allJobIds: string[];
  guideline_id: string;
  guideline_version: number;
}): AccuracyReportFilters {
  return {
    job_ids: params.selectedJobIds.length ? params.selectedJobIds : params.allJobIds,
    url_statuses: params.selectedStatuses.length ? params.selectedStatuses : ['reviewed'],
    guideline_id: params.guideline_id,
    guideline_version: params.guideline_version,
  };
}

export function previewEvaluationScope(
  jobs: MockJob[],
  filters: AccuracyReportFilters
): EvaluationScopePreview {
  const jobIdSet = new Set(filters.job_ids);
  const statusSet = new Set<UrlStatus>(filters.url_statuses);
  const included: EvaluationUrlPreview[] = [];
  const excluded: EvaluationUrlPreview[] = [];

  for (const job of jobs.filter((j) => jobIdSet.has(j.id))) {
    for (const url of job.url_process_results) {
      const row: EvaluationUrlPreview = {
        job_id: job.id,
        job_name: job.job_name,
        url_id: url.id,
        url: url.url,
        status: url.status,
        violation_count: (url.violations || []).length,
        existence_category_count: Object.keys(url.category_content_existence_entries || {}).length,
      };
      if (statusSet.has(url.status)) {
        included.push(row);
      } else {
        excluded.push(row);
      }
    }
  }

  return { filters, included, excluded };
}
